import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGooglePodcasts$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePodcasts extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd952a8b098e3a5a6a903a1788da44744b813dff3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd1f723c2aba29d90398173fc0e4fc0424831cec3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '24405051eb885dd5064563b500fafe55d32561df', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1M7.455 6.182a1 1 0 0 0-1 1v3.568a1 1 0 0 0 1.999 0V7.182a1 1 0 0 0-1-1M4 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1m14 0a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1M6.455 13.727a1 1 0 1 1 2 0v1.091a1 1 0 1 1-2 0zm7.09-6.545a1 1 0 1 1 2 0v1.09a1 1 0 1 1-2 0zM10 16.909a1 1 0 1 1 2 0V18a1 1 0 1 1-2 0zm4.546-6.636a1 1 0 0 0-1 1v3.545a1 1 0 1 0 2 0v-3.545a1 1 0 0 0-1-1M11 7.09a1 1 0 0 1 1 1v5.818a1 1 0 1 1-2 0V8.091a1 1 0 0 1 1-1", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google-podcasts", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-podcasts"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-podcasts":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePodcasts$1);
            }
            break;
    } });
}

const CosmosIconGooglePodcasts = CosmosIconGooglePodcasts$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePodcasts, defineCustomElement };
